import * as React from "react";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import {OnFailure, OnSuccessData} from "../../../../store/action/actionHelpers";
import {createUser} from "../../../../store/action/user/user";
import Toast from "../../../helper/Toast";
import CreateUserFormView from "./CreateUserFormView";
import UserData from "../../../../model/user/UserData";
import {none, Option, option} from "ts-option";
import User from "../../../../model/user/User";

interface IComponentProps {
	/**
	 * On successful created organisation callback.
	 */
	onSuccess: () => void;
	/**
	 * On cancel button click.
	 */
	onCancel: () => void;
}

interface IDispatchProps {
	/**
	 * Crete organisation.
	 * @param {UserData} data
	 */
	createUser: (data: UserData,
		password: string,
		file: Option<File>,
		onSuccess: OnSuccessData<User>,
		onFailure: OnFailure) => void;
}

interface IState {
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * Image file of user
	 */
	file: Option<File>
}

type Props = IComponentProps & IDispatchProps;

class CreateUserForm extends React.PureComponent<Props, IState> {
	constructor(props: Props) {
		super(props);
		this.state = {isSubmitting: false, file: none};
		this.onSubmit = this.onSubmit.bind(this);
		this.onAddFile = this.onAddFile.bind(this);
	}

	render() {
		return (
			<CreateUserFormView onSubmit={this.onSubmit}
								onCancel={this.props.onCancel}
								onAddFile={this.onAddFile}
								onRemoveFile={() => this.setState({file: none})}
								isSubmitting={this.state.isSubmitting}/>
		);
	}

	onAddFile(file: File) {
		this.setState({file: option(file)})
	}

	onSubmit(data: UserData, password: string) {
		this.setState({isSubmitting: true}, () => {
			this.props.createUser(
				data,
				password,
				this.state.file,
				(user) => {
					Toast.success("User created", "User creation");
					this.props.onSuccess();
				},
				(error: any) => {
					let err: string;
					if (error && error.response && error.response.data.status == 409)
						err = `User with email '${data.username}' exists`;
					else
						err = "User creation failed";
					Toast.error(err, "User creation");
					this.setState({isSubmitting: false});
				}
			);
		});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		createUser: (data: UserData,
			password: string,
			file: Option<File>,
			onSuccess: OnSuccessData<User>,
			onFailure: OnFailure) =>
			dispatch(createUser(data, password, file, onSuccess, onFailure))
	};
}

export default connect(null, mapDispatchToProps)(CreateUserForm);